const magicKestrelSelector = '[onerror="invokePreload.onScriptError(this)"][onload="invokePreload.onScriptLoad(this)"]';
function toSelector(type) {
  return `link[rel="${type}"]${magicKestrelSelector}`;
}
const preloadTypeToRel = {
  /**
 *
 */
  default: "preload",
  /**
 *
 *
 */
  module: "modulepreload",
  /**
 *
 *
 */
  nomodule: "nomodulepreload",
  /**
 *
 *
 */
  dynamic: "dynamicpreload",
  /**
 *
 */
  systemjs: "systemjspreload"
};
Object.fromEntries(Object.entries(preloadTypeToRel).map(e => [e[0], toSelector(e[1])]));

window.invokePreload || (window.invokePreload = {});
const {
  invokePreload
} = window;

function setLifecycleData(element, attr, data) {
  element.setAttribute(attr, data);
}
function getLifecycleData(element, attr) {
  return element.getAttribute(attr);
}
function processPreloadState(element, preloadState = "success") {
  if (preloadState === "success" && element.hasAttribute("noinvoke")) {
    element.removeAttribute("noinvoke");
    invokePreload.setLifecycleData(element, "data-preloaded", "noinvoke");
  } else {
    invokePreload.setLifecycleData(element, "data-preloaded", preloadState);
  }
  element.removeEventListener("load", invokePreload.onLoad);
  element.onload = null;
}

function activateStylesheet(link) {
  link.setAttribute("rel", "stylesheet");
  link.setAttribute("type", "text/css");
  link.setAttribute("media", "all");
  link.removeAttribute("as");
}
function processCss(link) {
  if ([].map.call(document.styleSheets, stylesheet => {
    try {
      return stylesheet.media.mediaText === "all" ? stylesheet.href : null;
    } catch (e) {
      return null;
    }
  }).indexOf(link.href) === -1) {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() => activateStylesheet(link));
    } else {
      activateStylesheet(link);
    }
  }
  link.removeAttribute("onload");
  return link;
}

function detectDynamicImportSupport(detector = "return import('data:text/javascript;base64,Cg==')") {
  try {
    new Function(detector)();
    return true;
  } catch (e) {
    return false;
  }
}
function createDetectorScript(isModule) {
  const check = document.createElement("script");
  const code = "window.invokePreload.browserSupport.typemodule=".concat(isModule.toString(), ";\n", "window.invokePreload.browserSupport.detectionComplete=true;\n", 'document.dispatchEvent(new CustomEvent("PreloadFeatureDetectionComplete"));');
  if (isModule) {
    check.type = "module";
  } else {
    check.setAttribute("nomodule", "true");
  }
  try {
    check.appendChild(document.createTextNode(code));
    document.head.appendChild(check);
  } catch (e) {
    check.text = code;
    document.head.appendChild(check);
  }
}
function detectScriptTypeModuleSupport() {
  const check = document.createElement("script");
  if ("noModule" in check) {
    return true;
  }
  [false, true].forEach(createDetectorScript);
  return false;
}
function detectPreloadFeatures() {
  const rels = document.createElement("link").relList;
  return rels ? {
    preload: rels.supports("preload"),
    modulepreload: rels.supports("modulepreload")
  } : {
    preload: false,
    modulepreload: false
  };
}

function detectFeatures() {
  const res = {
    preload: false,
    modulepreload: false,
    typemodule: false,
    dynamicimport: false,
    detectionComplete: false
  };
  invokePreload.browserSupport = res;
  try {
    const {
      modulepreload,
      preload
    } = detectPreloadFeatures();
    res.modulepreload = modulepreload;
    res.preload = preload;
    if (res.modulepreload) {
      res.typemodule = true;
      res.dynamicimport = true;
      res.detectionComplete = true;
      return res;
    }
    res.dynamicimport = detectDynamicImportSupport();
    if (res.dynamicimport) {
      res.typemodule = true;
      res.detectionComplete = true;
      return res;
    }
    res.typemodule = detectScriptTypeModuleSupport();
    if (res.typemodule) {
      res.detectionComplete = true;
      return res;
    }
  } catch (e) {
    res.detectionComplete = true;
  }
  return res;
}

detectFeatures();
invokePreload.setLifecycleData = setLifecycleData;
invokePreload.getLifeCycleData = getLifecycleData;
invokePreload.onLoad = processPreloadState;
invokePreload.onScriptLoad = processPreloadState;
invokePreload.onScriptError = link => invokePreload.onScriptLoad(link, "try-with-error");
invokePreload.onStyleLoad = processCss;
/*                                  */
